<div *ngIf="showBanner && maintenanceInfo" 
     class="relative z-50 bg-amber-50 dark:bg-amber-900/20 border-b border-amber-200 dark:border-amber-800 shadow-sm animate-slide-down">
  <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
    <div class="flex items-start sm:items-center justify-between py-3 gap-4">
      <div class="flex items-start sm:items-center min-w-0 flex-1">
        <div class="flex-shrink-0 mt-0.5 sm:mt-0">
          <mat-icon class="text-amber-600 dark:text-amber-400 text-xl">warning</mat-icon>
        </div>
        <div class="ml-3 min-w-0 flex-1">
          <p class="text-sm font-medium text-amber-800 dark:text-amber-200 leading-relaxed">
            <span class="font-semibold">Scheduled Maintenance</span>
            <span *ngIf="getFormattedDateTimeRange()" class="ml-2">
              {{ getFormattedDateTimeRange() }}
            </span>
            <span *ngIf="maintenanceInfo.maintenanceDuration" class="ml-2">
              (Duration: {{ maintenanceInfo.maintenanceDuration }})
            </span>
          </p>
          <p *ngIf="maintenanceInfo.maintenanceMessage" 
             class="mt-1 text-sm text-amber-700 dark:text-amber-300 leading-relaxed break-words">
            {{ maintenanceInfo.maintenanceMessage }}
          </p>
        </div>
      </div>
      <div class="flex-shrink-0">
        <!-- <button mat-icon-button 
                (click)="closeBanner()" 
                class="text-amber-600 dark:text-amber-400 hover:text-amber-800 dark:hover:text-amber-200 transition-colors duration-200 focus:outline-none focus:ring-2 focus:ring-amber-500 focus:ring-offset-2 dark:focus:ring-offset-gray-900 p-1">
          <mat-icon class="text-xl">close</mat-icon>
        </button> -->
      </div>
    </div>
  </div>
</div> 